import { CASHBACK, DEALS, GAMING } from 'components/pages/pages';

export type OffersType = 'deal' | 'cashback' | 'gaming';
export interface Category {
  tag: string;
  name: string;
  description: Record<OffersType, string>;
}

export const OFFER_TYPES = {
  deal: {
    name: 'Deals',
    description:
      'Find deals and money saving coupons on the biggest brands around or just let us show you ones you’ll like.',
    path: DEALS.path,
    plural: 'deals',
  },
  cashback: {
    name: 'Cashback',
    description:
      'Earn cashback on great products and enjoy your wallet being a little bigger at the end of the month.',
    path: CASHBACK.path,
    plural: 'cashback offers',
  },
  gaming: {
    name: 'Gaming',
    description:
      'Earn cashback playing our top games and enjoy your wallet being a little bigger at the end of the month.',
    path: GAMING.path,
    plural: 'gaming offers',
  },
};

const OFFER_CATEGORIES: Category[] = [
  {
    tag: 'automotive',
    name: 'Automotive',
    description: {
      deal: 'Save on automotive products with great deals and money saving coupons.',
      cashback:
        'Earn cashback on automotive products and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'kids',
    name: 'Baby & Kids',
    description: {
      deal: 'Save on products for children with great deals and money saving coupons.',
      cashback:
        'Earn cashback on products for children and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'beauty',
    name: 'Beauty & Spas',
    description: {
      deal: 'Save on beauty products with great deals and money saving coupons.',
      cashback:
        'Earn cashback on beauty products and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'business',
    name: 'Business Services',
    description: {
      deal: 'Save on business products with great deals and money saving coupons.',
      cashback:
        'Earn cashback on business products and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'media',
    name: 'Entertainment',
    description: {
      deal: 'Save on entertainment with great deals and money saving coupons.',
      cashback:
        'Earn cashback on entertainment and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'fashion',
    name: 'Fashion',
    description: {
      deal: 'Save on fashion with great deals and money saving coupons.',
      cashback:
        'Earn cashback on fashion and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'finance',
    name: 'Finance',
    description: {
      deal: 'Save on finance with great deals and money saving coupons.',
      cashback:
        'Earn cashback on finance and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'food',
    name: 'Food & Drink',
    description: {
      deal: 'Save on food & drink with great deals and money saving coupons.',
      cashback:
        'Earn cashback on food & drink and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'men',
    name: 'For Men',
    description: {
      deal: 'Save on products for men with great deals and money saving coupons.',
      cashback:
        'Earn cashback on products for men and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'women',
    name: 'For Women',
    description: {
      deal: 'Save on products for women with great deals and money saving coupons.',
      cashback:
        'Earn cashback on products for women and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'gambling',
    name: 'Gambling',
    description: {
      deal: 'Save on gambling with great deals and money saving coupons.',
      cashback:
        'Earn cashback on gambling products and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'gaming',
    name: 'Gaming',
    description: {
      deal: 'Save on games and enjoy your wallet being a little bigger at the end of the month.',
      cashback:
        'Earn cashback on games and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'gifts',
    name: 'Gifts',
    description: {
      deal: 'Save on gifts with great deals and money saving coupons.',
      cashback:
        'Earn cashback on gifts and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'groceries',
    name: 'Groceries & Household',
    description: {
      deal: 'Save on groceries with great deals and money saving coupons.',
      cashback:
        'Earn cashback on groceries and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'health',
    name: 'Health & Fitness',
    description: {
      deal: 'Save on health products with great deals and money saving coupons.',
      cashback:
        'Earn cashback on health products and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'home',
    name: 'Home',
    description: {
      deal: 'Save on products for the home with great deals and money saving coupons.',
      cashback:
        'Earn cashback on products for the home and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'insurance',
    name: 'Insurance',
    description: {
      deal: 'Save on insurance with great deals and money saving coupons.',
      cashback:
        'Earn cashback on insurance and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'pets',
    name: 'Pets',
    description: {
      deal: 'Save on pet products with great deals and money saving coupons.',
      cashback:
        'Earn cashback on pet products and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'seasonal',
    name: 'Seasonal',
    description: {
      deal: 'Get great deals and money saving coupons for everything you need this season.',
      cashback: 'Earn amazing cashback on everything you need for this season.',
      gaming: '',
    },
  },
  {
    tag: 'shopping',
    name: 'Shopping',
    description: {
      deal: 'Save on shopping with great deals and money saving coupons.',
      cashback:
        'Earn cashback on shopping and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'sport',
    name: 'Sport & Outdoors',
    description: {
      deal: 'Save on sports with great deals and money saving coupons.',
      cashback:
        'Earn cashback on sport and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'tech',
    name: 'Tech',
    description: {
      deal: 'Save on tech with great deals and money saving coupons.',
      cashback:
        'Earn cashback on tech and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'travel',
    name: 'Travel',
    description: {
      deal: 'Save on Travel with great deals and money saving coupons.',
      cashback:
        'Earn cashback on Travel and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
  {
    tag: 'todo',
    name: 'Experiences & Activities',
    description: {
      deal: 'Save on experiences and activities with great deals and money saving coupons.',
      cashback:
        'Earn cashback on experiences & activities and enjoy your wallet being a little bigger at the end of the month.',
      gaming: '',
    },
  },
];

export const GAMING_CATEGORIES: Category[] = [
  {
    tag: 'android',
    name: 'Android',
    description: {
      deal: '',
      cashback: '',
      gaming: 'Play games on your Android device and earn rewards.',
    },
  },
  {
    tag: 'ios',
    name: 'iOS',
    description: {
      deal: '',
      cashback: '',
      gaming: 'Play games on your iOS device and earn rewards.',
    },
  },
];

export default OFFER_CATEGORIES;
